import { useI18n, t } from "@bookingcom/lingojs-react";
import { useSelector } from "react-redux";
import { getSearch } from "../../store/search/selectors";
import { getFlight } from "../../store/flightDetails/selectors";
import { getOrder } from "../../store/order/selectors";

const useFareFeaturesHeading = () => {
  const search = useSelector(getSearch);
  const flight = useSelector(getFlight);
  const order = useSelector(getOrder);
  const i18n = useI18n();

  const totalTravellersOnOrder = order?.airOrder?.passengerPrices?.length || 0;
  const totalTravellersOnSearch = (search.adults || 0) + (search.children || []).length;
  const totalTravellersOnFunnel = (flight?.travellers && flight?.travellers?.length) || 0;
  const hasMultipleTravellers =
    totalTravellersOnSearch > 1 || totalTravellersOnFunnel > 1 || totalTravellersOnOrder > 1;

  return i18n.trans(hasMultipleTravellers ? t("flights_bf_included_total") : t("flight_fare_included"));
};

export default useFareFeaturesHeading;
